.customer-organization-form__edit-administrator-container {
  width: 360px;
}

.customer-organization-form__edit-administrator-done-button {
  margin-right: 1.6rem;
}
